import './index.css'
import * as React from 'react'
import DataTable from 'components/ui/data-table'
import TextOverflow from 'components/ui/text-overflow'
export default class ReportPreview extends React.Component<
  {
    data: {
      table_structure: [string, string][]
      rows: {
        beginning: boolean
        cols: [string, string][]
      }[]
    }
  },
  {
    hasScroll: boolean
    scrolled: boolean
  }
> {
  state: {
    hasScroll: boolean
    scrolled: boolean
  } = {
    hasScroll: false,
    scrolled: false,
  }
  _scroller: any | null | undefined = null

  componentDidMount() {
    this._measure()
  }

  componentDidUpdate() {
    this._measure()
  }

  _measure() {
    if (!this._scroller) return

    if (!this.state.hasScroll) {
      const hasScroll = this._scroller.scrollWidth > this._scroller.clientWidth

      if (hasScroll) {
        this.setState({
          hasScroll,
        })
      }
    }
  }

  _handlePreviewScroll: () => void = () => {
    if (!this._scroller) return
    if (this.state.scrolled) return
    if (this._scroller.scrollLeft === 0) return
    this.setState({
      scrolled: true,
    })
  }
  _handleScrollClick: () => void = () => {
    if (!this._scroller) return

    this._scroller.scrollBy(600, 0)

    this.setState({
      scrolled: true,
    })
  }

  _renderColname(str: string): React.ReactElement<'span'> | string {
    const reg = /(Writer .+) (\d+)/
    const match = reg.exec(str)

    if (match) {
      return (
        <span>
          {match[1]}&nbsp;{match[2]}
        </span>
      )
    }

    // TODO: Remove replace after renaming keys on backend
    return str.replace(/(Client|Internal) comment/i, '$1 note')
  }

  _renderTable(): null | React.ReactNode {
    const numberOfRows = this.props.data.rows.length

    if (numberOfRows === 0) {
      return null
    }

    return (
      <>
        <DataTable
          appearance="plain"
          columns={this.props.data.table_structure.map((column, index) => ({
            id: `cols[${index}][0]`,
            name: column[0],
            headerRender: (str: string) => this._renderColname(str),
            render: (item: Record<string, any>) => (
              <TextOverflow content={item as any} />
            ),
          }))}
          data={this.props.data.rows}
          scrollable
        />
      </>
    )
  }

  render(): React.ReactNode {
    return (
      <>
        {this.state.hasScroll && !this.state.scrolled ? (
          <div
            className="PlaylistReport_ScrollArrow"
            title="Scroll right"
            onClick={this._handleScrollClick}
          >
            ➤
          </div>
        ) : null}
        <div className="customer-reports_wrapper">{this._renderTable()}</div>
      </>
    )
  }
}
